"use strict";

const AssetRoutineMaintenanceData = function () {
  var organizeExistingData = function (data) {
    const [routineIssues, repairIssues] =
      RoutineMaintenanceConstants.extractRoutineAndRepairIssues(data);

    Object.assign(data, _groupIssuesBySection(routineIssues));
    data.activeMaintenanceIssues = repairIssues;

    return data;
  };

  var supportsStructuralCondition = function (config) {
    return config.inspectionTypeOptions.includes("routine-inspection");
  };

  var getNewInspectionDefaults = function (data, forcedInspectionType = null) {
    const assetInfo = data.assetInfo;
    const config = AssetTypeConfig.get(assetInfo.assetType);
    const activeMaintenanceIssues =
      RoutineMaintenanceFormTable.getDefaultMaintenanceTasksWithOptions(
        BmpFcsInventoryConstants.getAllMaintenanceTasks(),
        { maintenanceTasks: assetInfo.activeMaintenanceIssues ?? [] },
      );
    const defaultInspectionType = _getDefaultInspectionType(
      config,
      assetInfo,
      forcedInspectionType,
    );
    const canInspectStructuralCondition = supportsStructuralCondition(config);

    return {
      ...DryWeatherConstants.getStandardInspectionDefaults(activeMaintenanceIssues),
      ...(canInspectStructuralCondition
        ? _groupIssuesBySection(
            _getDefaultRoutineIssues(config, assetInfo, activeMaintenanceIssues),
          )
        : {}),
      activeMaintenanceIssues,
      assetInfo,
      inspectionType: defaultInspectionType,
      inspectStructuralConditionMaintenance:
        canInspectStructuralCondition && defaultInspectionType === "routine-inspection",
    };
  };

  // Maps a raw per-type asset (offline IndexedDB rows) onto the standard payload shape,
  var getNewInspectionDefaultsFromAsset = function (assetType, asset, forcedInspectionType = null) {
    const dryWeatherAsset = asset.asset ?? {};

    return getNewInspectionDefaults(
      {
        assetInfo: {
          ...AssetTypeConfig.get(assetType).mapAssetToAssetInfo(asset),
          dryWeatherCondition: dryWeatherAsset.dryWeatherCondition,
          reScreeningNeeded: dryWeatherAsset.reScreeningDryWeather?.isDue ?? false,
        },
      },
      forcedInspectionType,
    );
  };

  var _getDefaultInspectionType = function (config, assetInfo, forcedInspectionType) {
    const defaultType = WqMonitoringConstants.getDefaultInspectionTypeByTool(
      assetInfo.reScreeningNeeded,
      forcedInspectionType,
    );

    return config.inspectionTypeOptions.includes(defaultType)
      ? defaultType
      : config.inspectionTypeOptions[0];
  };

  var _getDefaultRoutineIssues = function (config, assetInfo, activeMaintenanceIssues) {
    const configKey = config.getMaintenanceTaskConfigKey(assetInfo);

    // Configured keys can be aliases of catalog tasks (`damage-inlet`), so build a row
    // per configured key instead of filtering the catalog by key.
    const configuredKeys = RoutineMaintenanceConfig.getConfiguredMaintenanceTasks(configKey);
    const configuredIssues = RoutineMaintenanceFormTable.getDefaultMaintenanceTasksWithOptions(
      BmpFcsInventoryConstants.getAllMaintenanceTasks(),
      { maintenanceTasks: configuredKeys.map((key) => ({ key })) },
    );

    return RoutineMaintenanceFormTable.filterIssuesBy(configuredIssues, activeMaintenanceIssues);
  };

  var _groupIssuesBySection = function (issues) {
    const sections = {
      structuralConditionIssues: [],
      structuralConditionInletIssues: [],
      structuralConditionOutletIssues: [],
    };

    for (const issue of issues) {
      if (issue.key.endsWith("-inlet")) {
        sections.structuralConditionInletIssues.push(issue);
      } else if (issue.key.endsWith("-outlet")) {
        sections.structuralConditionOutletIssues.push(issue);
      } else {
        sections.structuralConditionIssues.push(issue);
      }
    }

    return sections;
  };

  return {
    organizeExistingData,
    getNewInspectionDefaults,
    getNewInspectionDefaultsFromAsset,
    supportsStructuralCondition,
  };
};

module.exports = AssetRoutineMaintenanceData();

const AssetTypeConfig = require("./assetTypeConfig");
const BmpFcsInventoryConstants = require("../../bmpfcs/bmpFcsInventoryConstants");
const DryWeatherConstants = require("../../illicitDischarge/dryWeatherScreening/dryWeatherConstants");
const RoutineMaintenanceConfig = require("../../config/routineMaintenanceConfig");
const RoutineMaintenanceConstants = require("../../bmpfcs/routineMaintenanceConstants");
const RoutineMaintenanceFormTable = require("../../general/routineMaintenanceFormTable");
const WqMonitoringConstants = require("../../wq/inspection/wqMonitoringConstants");
